import { render, staticRenderFns } from "./lrBarcode.vue?vue&type=template&id=67c6af52"
import script from "./lrBarcode.vue?vue&type=script&lang=js"
export * from "./lrBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports